export enum OrderAddParamsSequenceOrder {
  ANY = "ANY",
  STRICT = "STRICT",
}

export type OrderAddParamsRideWaypointMetaCargoItem = {
  uuid: string;
};

export type OrderAddParamsRideWaypointMetaCargoItems = {
  subjects: OrderAddParamsRideWaypointMetaCargoItem[];
};

export type OrderAddParamsRideWaypointMeta = {
  uuid: string;
  cargoEnter: OrderAddParamsRideWaypointMetaCargoItems;
  cargoExit: OrderAddParamsRideWaypointMetaCargoItems;
};

export type OrderAddParamsRideWaypoint = {
  lat: number;
  lon: number;
  time?: string;
  haltingTime: number;
  displayName: string;
  meta: OrderAddParamsRideWaypointMeta;
};

export type OrderAddParamsRideWaypointGroup = {
  seq: OrderAddParamsRideWaypoint[];
  sequenceOrder: OrderAddParamsSequenceOrder;
};

export type OrderAddParamsRideSeqItem =
  | OrderAddParamsRideWaypoint
  | OrderAddParamsRideWaypointGroup;

export type OrderAddParamsCargoOrderRide = {
  seq: OrderAddParamsRideSeqItem[];
  sequenceOrder: OrderAddParamsSequenceOrder;
};

type OrderAddParams = {
  railyRide: OrderAddParamsCargoOrderRide;
  targetTaxiUuid: string | null;
  externalId: string | null;
  cargoTaxiContractUuid: string | null;
  assumeDispatcherUuid?: string;
};

export default OrderAddParams;
